export const BANNER_API = '/getSitewideSource'

export const CART_SUMMARY_API = '/cart-summary'

export const SUGGESTIONS_API = '/ssug?term='

export const CHANGE_SOURCE_API = '/source-change'
